module.exports = __webpack_public_path__ + "img/default-banner@0.33x.2110732c.jpg";